module.exports = __webpack_public_path__ + "static/media/ACG-banner-bg.7e6c8cf2.jpg";